import React, { Component } from "react";
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import PrivacyPolicyComponent from "./pages/PrivacyPolicy";
import DeleteAccountComponent from "./pages/DeleteAccount";
import AboutUsComponent from "./pages/AboutUs";
import HeaderComponent from "./components/Header/v2/Header";
import AirPortShuttleComponent from "./pages/AirportShuttle";
import EmergencyComponent from "./pages/EmergencyServices";
import JoyRideBookingComponent from "./pages/JoyRideBooking";
import BookWithUsComponent from "./pages/BookWithUs";
import BookingDetailComponent from "./pages/BookingDetail";
import BookingConfirmationComponent from "./pages/BookingConfirmation";
import PrivateChartersComponent from "./components/PrivateCharters";
import TermsComponent from "./components/Terms";
import HomeComponent from "./pages/Home";
import ChardhamByHelicopter from "./pages/ChardhamByHelicopter";
import { trackPageView } from "./utils/metaPixel";
import "./components/App.css";
import "./components/blaze.css";
import "./components/pure.css";
import "./components/grids-responsive-min.css";

// Pages that handle their own Meta Pixel tracking (with additional events)
const PAGES_WITH_CUSTOM_TRACKING = ["/booking", "/booking-confirmation"];

class App extends Component {
  componentDidMount() {
    this.trackPageViewIfNeeded();
  }

  componentDidUpdate(prevProps) {
    // Track page view on route change
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.trackPageViewIfNeeded();
    }
  }

  trackPageViewIfNeeded = () => {
    const { pathname } = this.props.location;
    // Only track PageView for pages that don't have custom tracking
    // Booking and booking-confirmation pages handle their own tracking
    if (!PAGES_WITH_CUSTOM_TRACKING.includes(pathname)) {
      trackPageView();
    }
  };

  render() {
    return (
      <div className="App">
        <HeaderComponent />
        <Switch>
          <Route path="/" exact component={HomeComponent} />
          <Route path="/booking" exact component={JoyRideBookingComponent} />
          <Route
            path="/booking-confirmation"
            exact
            component={BookingConfirmationComponent}
          />
          <Route
            path="/airport-shuttle"
            exact
            component={AirPortShuttleComponent}
          />
          <Route
            path="/emergency-services"
            exact
            component={EmergencyComponent}
          />
          <Route path="/bookwithus" exact component={BookWithUsComponent} />
          <Route
            path="/book/:scheduleName"
            exact
            component={BookingDetailComponent}
          />
          <Route
            path="/private-charters"
            exact
            component={PrivateChartersComponent}
          />
          <Route
            path="/privacy-policy"
            exact
            component={PrivacyPolicyComponent}
          />
          <Route
            path="/delete-account"
            exact
            component={DeleteAccountComponent}
          />
          <Route
            path="/terms-and-conditions"
            exact
            component={TermsComponent}
          />
          <Route
            path="/chardham-by-helicopter"
            exact
            component={ChardhamByHelicopter}
          />
          <Route path="/about-us" exact component={AboutUsComponent} />
          <Redirect from="/joy-rides" to="/bookwithus" />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);
